<p-progressSpinner
    styleClass="w-2rem h-2rem"
    strokeWidth="4"
    fill="var(--surface-ground)"
    animationDuration=".5s"
></p-progressSpinner>
